import styled from 'styled-components';

export const WaitingForMainWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        margin-top:4rem;
    `,
);

export const WaitingForInnerWrap = styled.div(
  props => `
        width:100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    `,
);

export const WaitingForHeadText = styled.h3(
  props => `
        font-size: 3.6rem
        color: #0a2731
        font-weight: 900;

        @media(max-width:1023px){
            text-align:center;
            font-size:2.4rem;
        }
    `,
);

export const WaitingForButton = styled.button(
  props => `
        width:21rem;
        display: flex;
        height:6.4rem;
        border-radius: 5rem;
        background-image: linear-gradient(92deg, #53b2fe 0%, #065af3 130%);
        text-transform: ${props.theme.font.textTransform.upper};
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.white.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        align-items: center;
        justify-content: center;
        border: none;
        cursor: pointer;
        margin-top:2.5rem;

        @media(max-width:1023px){
            width:18.5rem;
            height:5.6rem;
        }
    `,
);
